import type {EwBillersState, EwBillersActions} from './types';

const INITIAL_STATE: EwBillersState = {
  loading: false,
  error: false,
  data: {
    title: "",
    ReportBody: "",
  },
};

export default (
  state: EwBillersState = INITIAL_STATE,
  action: EwBillersActions
): EwBillersState => {
  switch (action.type) {
    case "REQUEST_EWBILLERS": {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case "REQUEST_EWBILLERS_FAILED": {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case "REQUEST_EWBILLERS_SUCCESS": {
      return {
        data: action.payload,
        loading: false,
        error: false,
      };
    }
    default:
      return state;
  }
}